import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

export interface FullScreenOption {
  backButtonIsHidden: string;
}

export class Station {

  public firstName: string | number;
  public lastName: string | number;
  public promotion: boolean;
  public fullScreen: boolean;
  public driveSafe: boolean;
  public blueProtect: boolean;

  constructor (
    public email?: string
  ) {
    this.firstName = '';
    this.lastName = '';
    this.email = email || '';
    this.promotion = false;
    this.fullScreen = true;
    this.driveSafe = false;
    this.blueProtect = false;
  }
}

@Injectable()
export class AdminService {

  private superSecretAdminPin: string;

  station: Station;

  formIsReady: boolean;
  showContent: boolean;

  backButtonOption: FullScreenOption;

  keypadInput: any;

  firstName: any;
  lastName: any;
  email: any;
  practice: any;
  website: any;
  phone: any;
  promotion: any;
  fullScreen: any;
  driveSafe: any;
  blueProtect: any;

  fields: any[];

  storageCache: string;

  constructor(
  ) {

    this.storageCache = 'idw483g';

    this.superSecretAdminPin = '1234';
    this.backButtonOption = { backButtonIsHidden: 'YES' };

    this.keypadInput = {
      model: null,
      placeholder: '',
      name: 'adminKey',
      type: 'tel'
    };

    // Fields
    this.firstName = {
      model: null,
      placeholder: 'first name',
      name: 'firstName',
      type: 'text',
      required: true
    };

    this.lastName = {
      model: null,
      placeholder: 'last name',
      name: 'lastName',
      type: 'text',
      required: true
    };

    this.email = {
      model: null,
      placeholder: 'email',
      name: 'email',
      type: 'text',
      required: true
    };

    this.practice = {
      model: null,
      placeholder: 'practice name',
      name: 'practice',
      type: 'text',
      required: false
    };

    this.website = {
      model: null,
      placeholder: 'website',
      name: 'website',
      type: 'text',
      required: false
    };

    this.phone = {
      model: null,
      placeholder: 'telephone',
      name: 'phone',
      type: 'tel',
      required: true
    };

    this.promotion = {
      model: false,
      name: 'promotion',
      type: 'toggle',
      label: 'Turn on Promotion',
      selected: false,
      options: [
        {
          index: 0,
          label: null,
          value: false
        },
        {
          index: 1,
          label: null,
          value: true
        }
      ]
    };

    this.fullScreen = {
      model: this.backButtonOption,
      name: 'fullScreen',
      type: 'toggle',
      label: 'Full Screen',
      selected: true,
      options: [
        {
          index: 0,
          label: null,
          value: this.backButtonOption
        },
        {
          index: 1,
          label: null,
          value: this.backButtonOption // we are hiding for both options
        }
      ]
    };

    this.driveSafe = {
      model: false,
      name: 'driveSafe',
      type: 'toggle',
      label: 'Include DriveSafe Products',
      selected: false,
      options: [
        {
          index: 0,
          label: null,
          value: false
        },
        {
          index: 1,
          label: null,
          value: true
        }
      ]
    };

    this.blueProtect = {
      model: false,
      name: 'blueProtect',
      type: 'toggle',
      label: 'Include Blue Protect Products',
      selected: false,
      options: [
        {
          index: 0,
          label: null,
          value: false
        },
        {
          index: 1,
          label: null,
          value: true
        }
      ]
    };

    this.fields = [
      this.firstName,
      this.lastName,
      this.email,
      this.practice,
      this.website,
      this.phone,
      this.promotion,
      this.fullScreen,
      this.driveSafe,
      this.blueProtect
    ];

  }

  init(): Observable<void> {
    return new Observable(observer => {
      this.station = JSON.parse(window.localStorage.getItem(`zeiss-ecp-settings-${this.storageCache}`));

      if (this.station) {
        this.fields.map((field: (any | any)) => {
          if (field.name !== 'fullScreen') {
            field.model =  this.station[field.name];
          }
        });
      } else {
        this.station = new Station();
      }

      observer.next();
      observer.complete();
    });
  }

  setSettings(): void {
    window.localStorage.setItem(`zeiss-ecp-settings-${this.storageCache}`, JSON.stringify(this.station));
  }

  isValidPin(): boolean {
    return this.keypadInput.model === this.superSecretAdminPin;
  }

  resetValidPin(): void {
    this.keypadInput.model = null;
  }

}



// WEBPACK FOOTER //
// ./src/services/admin.service.ts